<div (click)="onToggleFab()" *ngIf="fabTogglerState==='active'" id="fab-dismiss">
</div>
<div [style.flexDirection]="reverseColumnDirection?'column-reverse':'column'" class='fab-container'>
  <button (click)="onToggleFab()" class="fab-toggler"
          mat-fab>
    <i [@fabToggler]="{value: fabTogglerState}" class="material-icons">add</i>
  </button>
  <div [@speedDialStagger]="buttons.length" class="row">
    <button (click)="onClickFab(btn)" *ngFor="let btn of buttons"
            color="{{ activeButton && btn.title === activeButton.title ? 'primary' : 'secondary'}}" mat-raised-button>
      {{btn.title}}
    </button>
  </div>
  <div [@speedDialStagger]="subButtons.length" class="row">
    <button (click)="onClickSubFab(btn)" *ngFor="let btn of subButtons" color="secondary" mat-raised-button>
      {{btn.title}}
    </button>
  </div>
</div>
